import { createActionGroup, props } from '@ngrx/store';
import { Tracking } from '@panamax/app-state';

export const IMAGE_ORDERING_ANALYTICS_ACTIONS = createActionGroup({
  source: 'NgRxClient Analytics',
  events: {
    'Image Ordering Page Load': props<{ tracking: Tracking }>(),
    'Track Start Upload': props<{ tracking: Tracking }>(),
    'Track Finish Processing': props<{ tracking: Tracking }>(),
  },
});
